/* Copyright 2016-2021
   Kabandy
   Author: Cedric Hoarau
 */

import { ITime, ITimeSerialized } from ".";
import { Timestamp } from "@google-cloud/firestore";

export module ContractDataModel {
    export enum EErrorMsg {
        Update = "Can't update contract"
    }

    export enum EUpdateErrorReason {
        ContractNotFound = "Contract not found",
        InvalidField = "Invalid field"
    }

    export enum EStatus {
        FreetrialActive = "freetrial-active",
        FreetrialExpired = "freetrial-expired",
        FreetrialPending = "freetrial-pending",
        FreetrialRejected = "freetrial-rejected",
        Expired = "expired",
        Pending = "pending",
        Subscribed = "subscribed",
        CommercialActive = "commercial-active",
        CommercialInactive = "commercial-inactive",
        TestActive = "test-active",
        TestInactive = "test-inactive"
    }

    // these statuses have workflow/code linked to them
    export const FreetrialStatus = {
        FreetrialActive: EStatus.FreetrialActive,
        FreetrialExpired: EStatus.FreetrialExpired,
        FreetrialPending: EStatus.FreetrialPending,
        FreetrialRejected: EStatus.FreetrialRejected
    };

    //
    // --- Abstract

    interface IAbstractContract {
        id: string;
        name: string;
        customerOrganization: string;
        accessesCount: number;
        startDate: Timestamp | number;
        endDate: Timestamp | number;
        time: ITime | ITimeSerialized;
        status: typeof EStatus[keyof typeof EStatus];
    }
    interface IAbstractCreateInfo {
        contractId?: string;
        name: string;
        customerOrganization: string;
        accessesCount: number;
        startDate: Timestamp;
        endDate: Timestamp;
        status: typeof EStatus[keyof typeof EStatus];
    }
    interface IAbstractDeleteInfo {
        contractId: string;
    }
    interface IAbstractDeleteResponse {
        contractId: string;
        contractsCount: number;
        accessesCount: number;
        accessPeriodsCount: number;
        rolesCount: number;
        externalCompanyCount?: number;
    }
    interface IAbstractGetInfo {
        contractId: string;
    }
    interface IAbastractUpdateInfo {
        contractId: string;
        name?: string;
        customerOrganization?: string;
        accessesCount?: number;
        startDate?: Timestamp;
        endDate?: Timestamp;
        status?: typeof EStatus[keyof typeof EStatus];
    }

    //
    // --- Database

    export module Database {
        export interface IContract extends IAbstractContract {}
        export interface ICreateInfo extends IAbstractCreateInfo {}
        export interface IDeleteInfo extends IAbstractDeleteInfo {}
        export interface IDeleteResponse extends IAbstractDeleteResponse {}
        export interface IGetInfo extends IAbstractGetInfo {}
        export interface IUpdateInfo extends IAbastractUpdateInfo {}
    }

    export module Web {
        export interface IContractSerialized extends IAbstractContract {
            startDate: number;
            endDate: number;
            time: ITimeSerialized;
        }
    }
}
